import React, { Component } from "react";

import { flow } from "lodash";
import { requestAllDentalPlans } from "QuotePage/Actions";
import { getNumEmployeeProfiles, getNumDependents } from "QuotePage/Selectors";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import writtenNumber from "written-number";

import { TitleSmall } from "Cobalt/Header";
import { receiveABTest } from "Common/abTestUtils/redux";
import BodyText from "Common/BodyText";
import { Div } from "Common/HTML";
import { LoadingContainer } from "Common/LoadingContainer";
import { SizeSwitch } from "Common/Responsive";

import DentalCard from "./DentalCard";
import NeedMedicalModal from "./NeedMedicalModal";
import NoPlansCard from "./NoPlansCard";
import PlansFilterPanel from "./PlansFilterPanel";
import { getFilteredDentalPlans, isLoadingDentalPlans, getRecommendedVisibleDentalPlans, getOtherVisibleDentalPlans } from "./Selectors";

import type { Dispatch } from "redux";
import type { DentalPlan } from "Utils/types";

type Props = {
  isLoadingPlans: boolean;
  allPlansLength: number;
  visiblePlans: Array<DentalPlan>;
  loadDentalPlans: () => void;
  loadAbTest: (arg0: any) => void;
  currentSort: string;
  numDependents: number;
  numEmployees: number;
  state: string;
  city: string;
  recommendedPlans: Array<DentalPlan>;
  showRecommendedPlans: boolean;
  otherPlans: Array<DentalPlan>;
};

type State = {
  showModal: boolean;
};

export class DentalQuotePageDumb extends Component<Props, State> {
  state: State = {
    showModal: false,
  };

  componentDidMount() {
    this.props.loadDentalPlans();
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal() {
    AnalyticsTracking.trackEvent("viewed_need_medical_modal", {});
    this.setState({ showModal: true });
  }

  render() {
    return (
      <>
        {this.renderContent()}
        <NeedMedicalModal show={this.state.showModal} onHide={this.closeModal.bind(this)} />
      </>
    );
  }

  renderContent() {
    const { showRecommendedPlans } = this.props;
    return (
      <>
        {this.renderFilters()}
        {this.renderPlansHeader()}
        {!showRecommendedPlans && this.renderAllPlans()}
        {showRecommendedPlans && this.renderRecommendedPlans()}
        {showRecommendedPlans && this.renderOtherPlansHeader()}
        {showRecommendedPlans && this.renderOtherPlans()}
        {this.renderNoPlansCard()}
      </>
    );
  }

  renderAllPlans() {
    if (this.props.isLoadingPlans) {
      return <LoadingContainer />;
    }
    const plans = this.props.visiblePlans.map((plan) => <DentalCard key={plan.id} plan={plan} openModal={this.openModal.bind(this)} />);

    return <div>{plans}</div>;
  }

  renderRecommendedPlans() {
    const plans = this.props.recommendedPlans.map((plan) => <DentalCard key={plan.id} plan={plan} openModal={this.openModal.bind(this)} />);

    return <div>{plans}</div>;
  }

  renderOtherPlans() {
    const plans = this.props.otherPlans.map((plan) => <DentalCard key={plan.id} plan={plan} openModal={this.openModal.bind(this)} />);

    return <div>{plans}</div>;
  }

  renderPlansHeader() {
    const { city, state, showRecommendedPlans } = this.props;

    let regionCopy;
    if (city && state) {
      regionCopy = `${city}, ${state}`;
    } else if (city) {
      regionCopy = `${city}`;
    } else {
      regionCopy = `Your Area`;
    }

    const displayText = `${showRecommendedPlans ? "Best Plans " : "Plans "}`;

    return (
      <div>
        <Div style={{ display: "flex", justifyContent: "space-between" }}>
          <TitleSmall mt={0} mb={0}>
            {displayText}
            <span className="max-md:hidden">{` in ${regionCopy}`}</span>
            <SizeSwitch sm={this.renderPersonalizationText()} />
          </TitleSmall>
        </Div>
      </div>
    );
  }

  renderPersonalizationText() {
    const { numEmployees, numDependents } = this.props;
    const text =
      numEmployees > 0
        ? `Exact quote for ${writtenNumber(numEmployees)} employee${numEmployees == 1 ? "" : "s"} and ${writtenNumber(numDependents)} dependent${
            numDependents == 1 ? "" : "s"
          }`
        : "*Sample quote for 30 year old employee";

    return (
      <BodyText componentClass="span" weight="normal" pl={2}>
        ({text})
      </BodyText>
    );
  }

  renderOtherPlansHeader() {
    return (
      // Note: Updating the design for dental cards? Reduce the MT token by 1 after updating card margin-bottom
      <TitleSmall mt={0} mb={5}>
        Other Plans
      </TitleSmall>
    );
  }

  renderNoPlansCard() {
    if (!this.props.isLoadingPlans && this.props.allPlansLength == 0) {
      return <NoPlansCard />;
    }
    return null;
  }

  renderFilters() {
    return (
      <Div mb={5}>
        <SizeSwitch sm={<PlansFilterPanel />} />
      </Div>
    );
  }
}

const mapStateToProps = (state) => ({
  visiblePlans: getFilteredDentalPlans(state),
  recommendedPlans: getRecommendedVisibleDentalPlans(state),
  showRecommendedPlans: getRecommendedVisibleDentalPlans(state).length > 0,
  otherPlans: getOtherVisibleDentalPlans(state),
  allPlansLength: getFilteredDentalPlans(state).length,
  isLoadingPlans: isLoadingDentalPlans(state),
  currentSort: "average_monthly_premium",
  numEmployees: getNumEmployeeProfiles(state),
  numDependents: getNumDependents(state),
  city: state.city,
  state: state.state,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  loadDentalPlans: () => {
    dispatch(requestAllDentalPlans());
  },
  loadAbTest: (payload) => {
    dispatch(receiveABTest(payload));
  },
});

const DentalQuotePage = flow(connect(mapStateToProps, mapDispatchToProps), withRouter)(DentalQuotePageDumb);

export default DentalQuotePage;
